import TableDataHead from "./TableDataHead";

export default TableDataHead;
